import {Component, inject, OnInit} from '@angular/core';
import {ContainerComponent} from "@coreui/angular";
import {UIStateEnum} from "../../enum/UIStateEnum";
import {FailedRefundService} from "../../services/failed-refund.service";
import {ErrorHandlingService} from "../../services/error-handling.service";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {FailedRefundsTableComponent} from "../../components/failed-refunds-table/failed-refunds-table.component";
import {IFailedRefund} from "../../interfaces/IFailedRefund";

@Component({
  selector: 'app-failed-refunds',
  standalone: true,
  imports: [
    ContainerComponent,
    MatProgressSpinner,
    FailedRefundsTableComponent
  ],
  templateUrl: './failed-refunds.component.html',
})
export class FailedRefundsComponent implements OnInit {
  public failedRefunds: IFailedRefund[] = [];
  public uiState: UIStateEnum = UIStateEnum.ShowLoading;
  public uiStateEnumForTemplate = UIStateEnum;

  private failedRefundService = inject(FailedRefundService);
  private errorHandlingService = inject(ErrorHandlingService);

  ngOnInit() {
    this.loadFailedRefunds();
  }

  private loadFailedRefunds() {
    this.uiState = UIStateEnum.ShowLoading;
    this.failedRefundService.getAllFailedRefunds().subscribe({
      next: (failed_refunds) => {
        this.failedRefunds = failed_refunds;
        this.uiState = UIStateEnum.ShowData;
      },
      error: (err) => {
        this.uiState = UIStateEnum.ShowData;
        this.errorHandlingService.displayPageLevelErrorMessage(err);
      }
    });
  }
}
